import React from "react";

export default function Body() {
  return (
    <div className="body-section">
      <div className="body-header">
        <img className="op-photo" src="../images/0-user-face.png" />

        <div className="op-info">
          <p className="op-id">momo</p>
          <p className="post-issue">发布讨论</p>
        </div>
      </div>
      <h4 className="body-title">
        💙💚前i3视角陈述。。。（新增i2哥哥视角。。。
      </h4>
      <div className="body-content">
        <p>
          如果我有一个朋友。。。是前i3。。。八百年前就脱粉了。。。想讲一些他曾经追星过程中。。。作为唯粉嗑到（破防）的瞬间。。。算违反组规吗。。。
        </p>
        <p>我朋友说。。。写在前面：</p>
        <p>
          其实小踩关于他们的🍬点的帖子特别多，我就不一一赘述了，只说一些我的视角中特别点的看法吧。
        </p>
        <p>
          我的心路历程差不多是铁血i3（哥哥独美）——他俩其实关系还可以吧——确实有点甜跟着岛鸡嗑两口吧那———他妈的该不会是真的吧——他妈的死给。
        </p>
        <p>
          🍬其实也都是那些糖，但是可以多少给大家补点新的嗑点吧，反正嗑药无罪就不要审判我了。。。
        </p>
        <p>
          以及，我是前i3，叙述的过程大部分是分析wjk的心态，介意我不端水分析的cp饭就别看了，这就是一个我在成长（小学鸡中二年代到用成年人的视角理智看待现实关系）和他们也在成长（随着他们关系变迁，让我从破防到嗑死的故事）
        </p>
        <p>最后，虽然跑路很久了，但是跑路本身和他俩是不是真的没什么关系。</p>
      </div>
    </div>
  );
}
